import React from 'react';
import { 
  HelpCircle,
  Car,
  Clock,
  Percent,
  FileText,
  Shield,
  Zap,
  TrendingUp,
  DollarSign,
  Repeat
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Car,
      title: 'Выбор автомобиля',
      description: 'Оценивайте стоимость владения, а не только цену. Новый автомобиль теряет до 20% стоимости в первый год.'
    },
    {
      icon: DollarSign,
      title: 'Первоначальный взнос',
      description: 'Чем выше первоначальный взнос, тем ниже процентная ставка и общая переплата по кредиту.'
    },
    {
      icon: Clock,
      title: 'Срок кредита',
      description: 'Меньший срок означает меньшую переплату, но больший ежемесячный платеж.'
    },
    {
      icon: Percent,
      title: 'Процентная ставка',
      description: 'Сравнивайте полную стоимость кредита (ПСК), а не только номинальную ставку.'
    },
    {
      icon: Shield,
      title: 'Страхование',
      description: 'КАСКО может быть обязательным условием банка, но позволяет снизить ставку на 1-2%.'
    },
    {
      icon: Repeat,
      title: 'Trade-In',
      description: 'Позволяет быстро обменять старый автомобиль, но оценка обычно на 5-15% ниже рыночной.'
    },
    {
      icon: Zap,
      title: 'Досрочное погашение',
      description: 'Всегда уточняйте условия досрочного погашения и отсутствие штрафов за это.'
    },
    {
      icon: TrendingUp,
      title: 'Платежеспособность',
      description: 'Не превышайте 30-40% от вашего ежемесячного дохода на выплаты по всем кредитам.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по автокредитованию
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <FileText className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Калькулятор для сравнения
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Сохраняйте варианты расчетов для сравнения и выбора оптимального автокредита.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Подробнее об автокредитах
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;